(function () {
  'use strict';

  // ---------- Date helpers ----------
  function toISO(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function parseISO(iso) {
    if (typeof iso !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
    const [y, m, d] = iso.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null;
    date.setHours(0, 0, 0, 0);
    return date;
  }

  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  // Gauss algorithm for Easter Sunday (Gregorian)
  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  const HOLIDAY_CACHE = {};
  function germanHolidaysForYear(year) {
    if (HOLIDAY_CACHE[year]) return HOLIDAY_CACHE[year];
    const set = new Set([
      year + '-01-01',
      year + '-05-01',
      year + '-10-03',
      year + '-12-25',
      year + '-12-26'
    ]);
    const easter = easterSunday(year);
    const offsets = [-2, 1, 39, 50];
    for (const off of offsets) {
      const d = new Date(easter);
      d.setDate(d.getDate() + off);
      set.add(toISO(d));
    }
    HOLIDAY_CACHE[year] = set;
    return set;
  }

  function isGermanHoliday(date) {
    return germanHolidaysForYear(date.getFullYear()).has(toISO(date));
  }

  function isWorkingDay(date) {
    return !isWeekend(date) && !isGermanHoliday(date);
  }

  function addWorkingDays(date, n) {
    const result = new Date(date);
    result.setHours(0, 0, 0, 0);
    let added = 0;
    while (added < n) {
      result.setDate(result.getDate() + 1);
      if (isWorkingDay(result)) added++;
    }
    return result;
  }

  function workingDaysBetween(start, end) {
    const a = new Date(start); a.setHours(0, 0, 0, 0);
    const b = new Date(end);   b.setHours(0, 0, 0, 0);
    if (b <= a) return 0;
    let count = 0;
    const cursor = new Date(a);
    while (cursor < b) {
      cursor.setDate(cursor.getDate() + 1);
      if (isWorkingDay(cursor)) count++;
    }
    return count;
  }

  // ---------- Browser-console test harness ----------
  // Run in DevTools console: window.__deliveryDateTests()
  window.__deliveryDateTests = function () {
    const results = [];
    const ok = (cond, msg) => results.push({ pass: !!cond, msg });

    ok(toISO(easterSunday(2024)) === '2024-03-31', 'Easter 2024 = 2024-03-31');
    ok(toISO(easterSunday(2025)) === '2025-04-20', 'Easter 2025 = 2025-04-20');
    ok(germanHolidaysForYear(2025).has('2025-05-01'), 'Tag der Arbeit 2025 in set');
    ok(germanHolidaysForYear(2025).has('2025-04-18'), 'Karfreitag 2025 in set');
    ok(germanHolidaysForYear(2025).has('2025-12-26'), '2. Weihnachtsfeiertag 2025 in set');

    ok(isWeekend(new Date(2025, 0, 4)), 'Sat 2025-01-04 is weekend');
    ok(!isWeekend(new Date(2025, 0, 6)), 'Mon 2025-01-06 is not weekend');

    ok(!isWorkingDay(new Date(2025, 4, 1)), '2025-05-01 (Tag der Arbeit) is not a working day');
    ok(!isWorkingDay(new Date(2025, 0, 4)), 'Saturday is not a working day');
    ok(isWorkingDay(new Date(2025, 0, 6)), 'Monday 2025-01-06 is a working day');

    ok(toISO(addWorkingDays(new Date(2025, 0, 6), 3)) === '2025-01-09', 'addWorkingDays Mon+3 = Thu');
    ok(toISO(addWorkingDays(new Date(2025, 0, 3), 1)) === '2025-01-06', 'addWorkingDays Fri+1 skips weekend');
    ok(toISO(addWorkingDays(new Date(2025, 3, 30), 1)) === '2025-05-02', 'addWorkingDays skips 01.05.');

    ok(workingDaysBetween(new Date(2025, 0, 6), new Date(2025, 0, 10)) === 4, 'Mon→Fri = 4');
    ok(workingDaysBetween(new Date(2025, 0, 6), new Date(2025, 0, 6)) === 0, 'Mon→Mon = 0');
    ok(workingDaysBetween(new Date(2025, 0, 6), new Date(2025, 0, 13)) === 5, 'Mon→Mon+7 = 5');

    ok(parseISO('not-a-date') === null, 'parseISO rejects garbage');
    ok(parseISO('2025-02-30') === null, 'parseISO rejects 2025-02-30');
    ok(parseISO('2025-01-06') instanceof Date, 'parseISO accepts valid');

    const passed = results.filter(r => r.pass).length;
    const failed = results.length - passed;
    console.group('[delivery-date] tests: ' + passed + '/' + results.length + ' passed');
    for (const r of results) {
      console[r.pass ? 'log' : 'error']((r.pass ? '\u2713 ' : '\u2717 ') + r.msg);
    }
    console.groupEnd();
    return failed === 0;
  };

  window.__deliveryDateHelpers = {
    toISO, parseISO, isWeekend, isGermanHoliday, isWorkingDay,
    addWorkingDays, workingDaysBetween
  };

  // ---------- Alpine component ----------
  function DeliveryDatePicker() {
    return {
      selectedDate: '',
      workingDaysDiff: null,
      tier: 'standard',
      flatpickrInstance: null,
      saveTimeout: null,

      mounted() {
        const inputEl = this.$refs.dateInput;
        const initial = inputEl ? inputEl.value : '';
        const validated = this._validateInitial(initial);
        this.selectedDate = validated.iso;
        if (inputEl) inputEl.value = validated.iso;
        this._recomputeTier();
        if (validated.changed) {
          this._saveAttribute(validated.iso, true);
        }
        this._mountFlatpickr();
        if (inputEl && !this.flatpickrInstance) {
          inputEl.addEventListener('change', (e) => this.onChange(e.target.value));
        }
      },

      onChange(iso) {
        const parsed = parseISO(iso);
        if (!parsed) return;
        this.selectedDate = iso;
        this._recomputeTier();
        this._saveAttribute(iso, false);
      },

      _validateInitial(iso) {
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const minDate = addWorkingDays(today, 3);
        const parsed = parseISO(iso);
        const valid = parsed && parsed >= minDate && isWorkingDay(parsed);
        if (valid) return { iso, changed: false };
        return { iso: toISO(addWorkingDays(today, 12)), changed: true };
      },

      _recomputeTier() {
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const target = parseISO(this.selectedDate);
        if (!target) { this.tier = 'standard'; this.workingDaysDiff = null; return; }
        const diff = workingDaysBetween(today, target);
        this.workingDaysDiff = diff;
        if (diff > 9) this.tier = 'standard';
        else if (diff >= 7) this.tier = 'express';
        else this.tier = 'call';
      },

      _saveAttribute(iso, immediate) {
        const doSave = () => {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { requested_delivery_date: iso } })
          }).catch((err) => console.warn('[delivery-date] save failed', err));
        };
        if (this.saveTimeout) clearTimeout(this.saveTimeout);
        if (immediate) doSave();
        else this.saveTimeout = setTimeout(doSave, 300);
      },

      _mountFlatpickr() {
        if (typeof flatpickr === 'undefined') return;
        const inputEl = this.$refs.dateInput;
        if (!inputEl) return;
        const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
        const altFormatMap = { de: 'd.m.Y', fr: 'd/m/Y' };
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const config = {
          dateFormat: 'Y-m-d',
          altInput: true,
          altFormat: altFormatMap[lang] || 'm/d/Y',
          minDate: addWorkingDays(today, 3),
          disable: [(d) => !isWorkingDay(d)],
          defaultDate: this.selectedDate,
          onChange: (_dates, str) => this.onChange(str)
        };
        if (flatpickr.l10ns && flatpickr.l10ns[lang]) {
          config.locale = flatpickr.l10ns[lang];
        }
        this.flatpickrInstance = flatpickr(inputEl, config);
      }
    };
  }

  window.DeliveryDatePicker = DeliveryDatePicker;
})();
